import service from '@/utils/request'
export function modelListData(param) {
    return service.request({
        method: 'get',
        url: '/activiti/models/modelListData',
        data: param
    })
}
